import 'css-chunksrc/client/scenes/costProfileCreation/styles.scss';export default {
  "costProfileCreation": "_costProfileCreation_12rrc_1",
  "main": "_main_12rrc_5",
  "footer": "_footer_12rrc_14",
  "button": "_button_12rrc_22"
};